export default {
	activeIds: [],
	formSubmitted: false,
	activeFieldIndex: 0,
	progress: 1,
};
